import React, { useEffect, useState } from 'react';
import { logAmplitudeEvent } from '../util/analytics';

const PageContext = React.createContext();

const PageProvider = ({
  pageType,
  pageTitle,
  gameName,
  gameID,
  EntityConfigs,
  discordInvite,
  path,
  pageProps,
  children
}) => {
  const [pageState, setPageState] = useState({
    pageType,
    pageTitle,
    gameName,
    path,
    EntityConfigs,
    gameID,
    discordInvite
  });

  useEffect(() => {
    setPageState({
      pageType,
      pageTitle,
      gameName,
      gameID,
      path,
      EntityConfigs,
      discordInvite
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType, pageTitle, gameName, discordInvite, path]);

  useEffect(() => {
    logAmplitudeEvent('custom_page_view', {
      gameName,
      pageType,
      pageTitle,
      path,
      ...pageProps
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logEvent = (name, props) => {
    logAmplitudeEvent(name, { ...props, ...pageState });
  };

  return <PageContext.Provider value={{ ...pageState, logEvent }}>{children}</PageContext.Provider>;
};

export { PageContext, PageProvider };
